export const environment = {
  production: false,
  env: "uat",
  SSO: {
    stsServer: "https://uat-connect1.gs1.fr"
  },
  URL_Front: "https://uat-codeonline-gln.gs1.fr/",
  URL_Back: "https://app-colgln-app-uat-ne.azurewebsites.net/api/",
  URL_ECLI: "https://uat-monespaceclient.gs1.fr/",
  URL_NEW_CODE_ORDER: "https://uat-monespaceclient.gs1.fr/codes/GCP",
  ACCOUNTING_PERIOD: {
    start_date: "01/01/2024",
    end_date: "03/31/2024"
  }
};
